import ScopeItem from './ScopeItem.container';

export default ScopeItem;